import { FaStar } from "react-icons/fa";

const TqPanelExcessReduction = ({ text, className }) => (
  <div className={className}>
    <FaStar
      className="tw-h-4 tw-w-4 tw-shrink-0 tw-text-white"
      aria-hidden="true"
    />
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5">
      <b>Excess Reduction: </b>
      <span>{text}*</span>
    </div>
  </div>
);

export default TqPanelExcessReduction;
